import { fetchWithErrorHandling, buildPostOptions, buildGetOptions } from "../FetchUtils";
import { useAuthUser } from "react-auth-kit";
import { useContext } from "react";
import { AppContext } from "../../utils/AppContext";
import { getBaseURL } from "utils/Environment";
import { IDataEntity } from "./DataSchemaService";

export interface INeighborhood extends IDataEntity {
  name: string;
  persistentActionContainerId?: string;
  placedObjectContainerId?: string;
  creationDate: number;
  serverId: string;
  playerIds: string[];
  neighborhoodSlotMap: { [key: number]: string };
}

export interface INeighborhoodCollection {
  cursor: string;
  list: INeighborhood[];
}

/**
 * Delete a neighborhood and its associated game server
 */
export const deleteNeighborhood = async (accessToken: string, baseURL: string, neighborhooddId: string) => {
  return fetchWithErrorHandling(baseURL + `v1/neighborhood/${neighborhooddId}`, {
    ...buildPostOptions(accessToken, {}),
    method: "DELETE",
  });
};

/**
 * List all neighborhoods
 */
export const listNeighborhoods = async (
  accessToken: string,
  baseURL: string,
  limit?: number,
  cursor?: string,
): Promise<INeighborhoodCollection> => {
  const queryParams = new URLSearchParams();

  if (limit) {
    queryParams.set("limit", limit.toString());
  }

  if (cursor) {
    queryParams.set("cursor", cursor);
  }

  return fetchWithErrorHandling(baseURL + `v1/neighborhood/list?${queryParams.toString()}`, {
    ...buildGetOptions(accessToken),
    method: "GET",
  });
};

/**
 * Hook to access Neighborhood service functions
 */
export const useNeighborhoodService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;
  const appContext = useContext(AppContext);

  return {
    delete: (neighborhoodId: string) => deleteNeighborhood(accessToken, getBaseURL(appContext), neighborhoodId),
    listNeighborhoods: (limit?: number, cursor?: string) =>
      listNeighborhoods(accessToken, getBaseURL(appContext), limit, cursor),
  };
};
